/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import styled from "styled-components";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";

function Header() {
  const [burgerStatus, setBurgerStatus] = useState(false);

  return (
    <Container>
      {/* Header */}
      <a href="#">
        <img src="/images/logo.svg" alt="Logo" />
      </a>
      <MenuGroup
        onClick={() => {
          alert("Coming Soon! Till then try clicking on Menu Icon!");
        }}
      >
        <div>Model S</div>
        <div>Model 3</div>
        <div>Model X</div>
        <div>Model Y</div>
      </MenuGroup>
      <RightMenu>
        <a href="#">Shop</a>
        {/* <a href="#">My Account</a> */}
        <MenuIconContainer onClick={() => setBurgerStatus(!burgerStatus)}>
          <MenuIcon />
        </MenuIconContainer>
      </RightMenu>
      <BurgerNav status={burgerStatus}>
        <CloseContainer onClick={() => setBurgerStatus(!burgerStatus)}>
          <Close>{/* <CloseIcon /> */}</Close>
        </CloseContainer>
        <li>
          {" "}
          <a href="#">Model S</a>
        </li>
        <li>
          {" "}
          <a href="#">Model 3</a>
        </li>
        <li>
          {" "}
          <a href="#">Model X</a>
        </li>
        <li>
          <a href="#">Existing Inventory</a>
        </li>
        <li>
          <a href="#">Used Inventory</a>
        </li>{" "}
        <li>
          <a href="#">Cybertruck</a>
        </li>{" "}
        <li>
          <a href="#">Roadster</a>
        </li>{" "}
        <li>
          <a href="#">Spaceship</a>
        </li>
      </BurgerNav>
    </Container>
  );
}

export default Header;

const Container = styled.div`
  display: flex;
  min-height: 60px;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;

  // for header to stay during scroll
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
`;

const MenuGroup = styled.div`
  display: flex;
  text-transform: uppercase;
  // margin: 0 auto;
  div {
    font-weight: 600;
    padding: 0 10px;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;
const RightMenu = styled.div`
  display: flex;
  align-items: center;
  a {
    font-weight: 600;
    text-transform: uppercase;
    padding-right: 15px;
    account {
      @media (max-width: 768px) {
        display: none;
      }
    }
  }
`;

const MenuIconContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const BurgerNav = styled.div`
  position: fixed;
  width: 300px;
  background: white;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 20px;
  list-style: none;

  transform: ${(props) =>
    props.status ? "translateX(0)" : "translateX(100%)"};
  transition: transform 0.2s ease-in;

  // transform: translateX(100%);
  li {
    padding: 15px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    a {
      font-weight: 600;
    }
  }
`;

const Close = styled(CloseIcon)`
  cursor: pointer;
`;

const CloseContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
